import { render, staticRenderFns } from "./PermanentDeleteDialog.vue?vue&type=template&id=476f2374&scoped=true&"
import script from "./PermanentDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./PermanentDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476f2374",
  null
  
)

export default component.exports